import { ReactNode } from "react";
import styled from "styled-components";
import { Color } from "../theme/Color";
import { FontSizes } from "../theme/FontSize";

interface HeadingProps {
  size?: -3 | -2 | -1 | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  fontColor?: Color;
  centered?: boolean;
  bold?: boolean;
  inline?: boolean;
  underline?: boolean;
  textTransform?: "none" | "uppercase";
  margin?: string;
  children: ReactNode;
}

const StyledHeading = styled.div<{
  size: number;
  color: Color;
  centered: boolean;
  bold: boolean;
  inline: boolean;
  underline: boolean;
  textTransform: string;
  margin: string;
}>`
  font-size: ${({ size }) => (size ? FontSizes[size] : FontSizes[0])};
  margin: ${({ size, margin }) => handleMargin(size, margin)};
  color: ${({ color }) => (color ? color : Color.Grey4)};
  line-height: 150%;
  text-align: ${({ centered }) => (centered ? "center" : "left")};
  font-weight: ${({ bold }) => (bold ? "700" : "500")};
  display: ${({ inline }) => (inline ? "inline" : "block")};
  text-transform: ${({ textTransform }) => textTransform};
  ${({ underline, size, color }) => handleUnderline(underline, size, color)};
`;

const handleMargin = (size, margin) => {
  if (margin === null) {
    // A margin has not been specified therefore
    // set the margin based on the size of the font
    switch (size) {
      case 1:
      case 2:
        margin = "0.5";
        break;
      case 3:
        margin = "0.75";
        break;
      case 4:
      case 5:
        margin = "1";
      case 6:
        margin = "1.2";
      case 7:
      case 8:
        margin = "1.5";
        break;
    }
  }
  return ` 
 ${margin};
    `;
};

const handleUnderline = (underline, size, color) => {
  if (underline) {
    let borderWeight = 2;

    switch (size) {
      case 3:
        borderWeight = 3;
        break;
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
        borderWeight = 4;
        break;
    }
    return ` 
    border-bottom: ${borderWeight}px solid ${color || Color.Grey4};
    `;
  }
};

const Heading = ({
  size = 0,
  fontColor = Color.Grey1,
  centered = false,
  bold = true,
  inline = false,
  underline = false,
  children,
  textTransform = "none",
  margin = null,
  ...props
}: HeadingProps) => {
  return (
    <StyledHeading
      {...props}
      size={size}
      color={fontColor}
      centered={centered}
      bold={bold}
      inline={inline}
      underline={underline}
      textTransform={textTransform}
      margin={margin}
    >
      {children}
    </StyledHeading>
  );
};

export default Heading;
